import React from "react";
import styles from "../../styles/Components/Shared/OptionsComponent.module.css";
const Ellipsis = '/static/img/SvgIcons/icons8-ellipsis.svg'

const OptionsComponent = ({openMenuIndex, setOpenMenuIndex, menuIndex, data, advancedEditOptions, menuRef, addedStyle}) => {

    const toggleMenu = (index, event) => {
        event.stopPropagation(); // Prevents triggering outside click handler
        
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    return (
        <div className={styles.moreOptions_modal_wrapper}>
            <div 
                className={styles.moreOptions_modal_button_container}
                onClick={(e) => toggleMenu(menuIndex, e)} 
                data-test={`testing-${menuIndex}`}
                style={addedStyle ? addedStyle : {}}
            >
                <img src={Ellipsis} alt={'Edit Options'} width={20} height={20} />
            </div>
            {
                openMenuIndex === menuIndex ? (
                <div className={styles.moreOptions_modal_container} ref={menuRef}>
                    {advancedEditOptions.map((option, i) => !(option.hideOption && option.hideOption(data)) ? (
                        <div key={`edit-option-${i}`}>
                            <p  className={(option.disabled || option.checkDisabled && option.checkDisabled(data)) ? styles.disabled_option : ''}
                                onClick={(e) => {
                                    if (option.disabled || option.checkDisabled && option.checkDisabled(data)) {
                                        return
                                    }
                                    
                                    toggleMenu(menuIndex, e)
                                    return option.cb ? option.cb(data) : {}
                                }}
                            >
                                {option.getName ? option.getName(data) : option.name}
                            </p>
                        </div>
                    ) : null)}
                </div>
                ) : null
            }
        </div>
    )
}

export default OptionsComponent;